// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "span.posted[data-v-65cdd218]{display:inline-block;margin-right:1em}", ""]);
// Exports
module.exports = exports;
